import React from 'react';
import styled from 'styled-components';
import jobsRepostingPlaceholder from './job-repost-placeholder.png';

const StyledJobRepostingContainer = styled.div`
  height: 361px;
  background-image: url(${jobsRepostingPlaceholder});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top center;

  text-align: center;
  position: relative;
`;

const StyledJobRepostingContent = styled.div`
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, 0);

  width: 70%;
  min-width: 300px;

  @media (max-width: 700px) {
    top: 30%;
  }
`;

const JobsRepostingEmptyState = () => (
  <StyledJobRepostingContainer>
    <StyledJobRepostingContent>
      <h5>No jobs to repost yet</h5>
      <div>Once you start posting jobs, you’ll be able to use them as a starting point for new posts</div>
    </StyledJobRepostingContent>
  </StyledJobRepostingContainer>
);

export default JobsRepostingEmptyState;
